/* NOT: docs/assets/cart-drawer.js.md — gerekceler ve gecmis orada */
class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());



    this.addEventListener('click', (evt) => {
      if (evt.target.id === 'CartDrawer-Overlay') this.close();
    });
    this.setHeaderCartIconAccessibility();
  }



  openPending(triggeredBy) {
    if (this.classList.contains('active')) return;
    this.setAttribute('data-mqle-pending', '');
    this.setAttribute('aria-busy', 'true');
    this.open(triggeredBy);
  }


  closePending() {




    this.clearOptimisticLine();
    if (!this.hasAttribute('data-mqle-pending')) return;
    this.removeAttribute('data-mqle-pending');
    this.removeAttribute('aria-busy');
    this.close();
  }








  readOptimisticData(source) {
    if (!source) return null;
    const kapsam =
      source.closest('[data-qa-panel], .card--product, product-component, mqle-pdp-main') ||
      source.closest('form')?.parentElement ||
      document;
    const metin = (sel, kok = kapsam) => kok.querySelector(sel)?.textContent?.trim() || '';

    const baslik =
      metin('[data-qa-title]') ||
      metin('.mqle-qa__title') ||
      metin('.card__title-link') ||
      document.querySelector('.mqle-product__title, .mqle-title, h1')?.textContent?.trim() ||
      '';
    if (!baslik) return null;

    const gorsel =
      kapsam.querySelector('.mqle-qa__slide img, .card__media img, [data-mqle-gallery-track] img') ||
      document.querySelector('[data-mqle-gallery-track] img');

    const adetGirdi =
      source.querySelector?.('[name="quantity"]') ||
      kapsam.querySelector('[name="quantity"], [data-qa-qty-input]');
    const adet = Math.max(1, parseInt(adetGirdi?.value, 10) || 1);




    const variantId =
      source.querySelector?.('[name="id"]')?.value ||
      kapsam.querySelector('[data-qa-add]')?.dataset.variantId ||
      '';

    return {
      baslik,
      varyant: metin('[data-mqle-shade-name]') || metin('[data-qa-shade-name]') || '',
      fiyat: metin('[data-mqle-current-price]') || metin('[data-card-price]') || metin('.mqle-price__current'),
      adet,
      variantId: String(variantId),
      gorselSrc: gorsel?.currentSrc || gorsel?.src || '',
      gorselAlt: gorsel?.alt || '',
    };
  }




  renderOptimisticLine(source) {
    const veri = this.readOptimisticData(source);
    if (!veri) return;

    this.clearOptimisticLine();




    if (veri.variantId) {
      const mevcutAdet = this.querySelector(
        `[data-quantity-variant-id="${CSS.escape(veri.variantId)}"]`
      );
      if (mevcutAdet) {
        const eski = parseInt(mevcutAdet.value, 10) || 1;
        mevcutAdet.dataset.mqleOptimisticPrev = String(eski);
        mevcutAdet.value = String(eski + veri.adet);
        this.querySelector('cart-drawer-items')?.setAttribute('aria-busy', 'true');
        return;
      }
    }






    let tbody = this.querySelector('cart-drawer-items tbody');
    if (!tbody) {
      const kap = this.querySelector('#CartDrawer-CartItems') || this.querySelector('cart-drawer-items');
      if (!kap) return;
      const sarmalayici = document.createElement('div');
      sarmalayici.className = 'drawer__cart-items-wrapper';
      sarmalayici.setAttribute('data-mqle-optimistic', '');
      const tablo = document.createElement('table');
      tablo.className = 'cart-items';
      tablo.setAttribute('role', 'table');
      tbody = document.createElement('tbody');
      tbody.setAttribute('role', 'rowgroup');
      tablo.appendChild(tbody);
      sarmalayici.appendChild(tablo);
      kap.appendChild(sarmalayici);
      this.querySelector('cart-drawer-items')?.classList.remove('is-empty');
    }

    const satir = document.createElement('tr');
    satir.className = 'cart-item';
    satir.setAttribute('role', 'row');
    satir.setAttribute('data-mqle-optimistic', '');



    const medya = document.createElement('td');
    medya.className = 'cart-item__media';
    medya.setAttribute('role', 'cell');
    if (veri.gorselSrc) {
      const img = document.createElement('img');
      img.className = 'cart-item__image';
      img.src = veri.gorselSrc;
      img.alt = veri.gorselAlt;
      medya.appendChild(img);
    }

    const detay = document.createElement('td');
    detay.className = 'cart-item__details';
    detay.setAttribute('role', 'cell');
    const ad = document.createElement('div');
    ad.className = 'cart-item__name h4 break';
    ad.textContent = veri.baslik;
    detay.appendChild(ad);
    if (veri.varyant) {
      const v = document.createElement('div');
      v.className = 'product-option';
      v.textContent = veri.varyant;
      detay.appendChild(v);
    }

    const toplam = document.createElement('td');
    toplam.className = 'cart-item__totals right';
    toplam.setAttribute('role', 'cell');
    if (veri.fiyat) {
      const f = document.createElement('span');
      f.className = 'price price--end';
      f.textContent = veri.fiyat;
      toplam.appendChild(f);
    }

    const adet = document.createElement('td');
    adet.className = 'cart-item__quantity';
    adet.setAttribute('role', 'cell');
    const adetMetni = document.createElement('span');
    adetMetni.className = 'mqle-optimistic__qty';
    adetMetni.textContent = `× ${veri.adet}`;
    adet.appendChild(adetMetni);

    satir.append(medya, detay, toplam, adet);
    tbody.appendChild(satir);


    this.querySelector('cart-drawer-items')?.setAttribute('aria-busy', 'true');

    this.classList.remove('is-empty');
    this.querySelector('.drawer__inner')?.classList.remove('is-empty');
  }

  clearOptimisticLine() {
    this.querySelectorAll('[data-mqle-optimistic]').forEach((n) => n.remove());


    this.querySelectorAll('[data-mqle-optimistic-prev]').forEach((n) => {
      n.value = n.dataset.mqleOptimisticPrev;
      delete n.dataset.mqleOptimisticPrev;
    });
    this.querySelector('cart-drawer-items')?.removeAttribute('aria-busy');
  }




  refreshFocusTrap() {
    const container = this.classList.contains('is-empty')
      ? this.querySelector('.drawer__inner-empty')
      : document.getElementById('CartDrawer');
    const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
    if (container && focusElement) trapFocus(container, focusElement);
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (this.classList.contains('active')) return;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);



    this.openFrame = requestAnimationFrame(() => {
      this.openFrame = null;
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    document.body.classList.add('overflow-hidden');




    this.querySelector('cart-drawer-items')?.dispatchViewEvent();
  }

  close() {



    if (this.openFrame) {
      cancelAnimationFrame(this.openFrame);
      this.openFrame = null;
    }
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {



    this.clearOptimisticLine();
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });



    if (this.hasAttribute('data-mqle-pending')) {
      this.removeAttribute('data-mqle-pending');
      this.removeAttribute('aria-busy');
      if (this.classList.contains('active')) this.refreshFocusTrap();
    }
    this.open();
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
